import React, { Component } from 'react';
import './MoreCards.css';

const MoreCards = () => {
    return ( <>
    <h2>More,</h2>
    
    
    
    
    
    </> );
}
 
export default MoreCards;